import React, { useEffect, useState } from 'react';
import Finance from '../../assets/components/finance';
import AppButton from '../base/button';
import usePayoutStore from '../../store/payout';
import { getCurrencySign } from '../../utils/string.util';
import { formatAmount } from '../../utils/amount.util';

const QuickActions: React.FC<{
  onAddNewBeneficiary: () => void;
  onNewPayoutRequest: () => void;
}> = ({ onAddNewBeneficiary, onNewPayoutRequest }) => {
  const { getAllTransactions } = usePayoutStore();
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState<any[]>([]);

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const response = await getAllTransactions({});
        setTransactions(response?.value?.transactions?.slice(0, 3) || []);
      } catch (error) {
        console.error('Error fetching transactions:', error);
        setTransactions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Quick Actions Section */}
      <div className="flex flex-col gap-3 items-center rounded-xl border border-[#F1F2F4] p-4">
        <div className="flex gap-3 w-full justify-between items-center bg-[#F1F2F4] rounded-xl p-4">
          <div className="flex flex-col gap-1">
            <p className="text-[#00307E] text-[24px] font-semibold">
              Quick Actions
            </p>
            <p className="text-[#111827] text-sm font-medium w-2/3">
              Start a new transaction or add beneficiaries
            </p>
          </div>
          <Finance />
        </div>

        <div className="w-full grid gap-2">
          <AppButton
            label="New Payout Request"
            type="primary"
            clicked={onNewPayoutRequest}
          />
          <AppButton
            label="Add New Beneficiary"
            type="light"
            clicked={onAddNewBeneficiary}
          />
        </div>
      </div>

      {/* Recent Activity Section */}
      <div className="flex flex-col gap-3 rounded-xl border border-[#F1F2F4] p-4 bg-[#F1F2F4]">
        <div className="w-full">
          <p className="text-[#111827] text-lg font-semibold">
            Recent Activity
          </p>
          <p className="text-[#111827] text-sm font-light">
            Your latest payout requests
          </p>
        </div>

        {/* Transactions List */}
        <div className="w-full">
          {loading ? (
            <p className="text-[#111827] text-sm font-light">
              Loading transactions...
            </p>
          ) : transactions.length > 0 ? (
            <ul className="space-y-2">
              {transactions.map((transaction, index) => (
                <li
                  key={index}
                  className="p-3 bg-white rounded-xl shadow-sm flex justify-between items-center"
                >
                  <div>
                    <p className="text-[#00307E] text-sm font-medium">
                      {transaction.beneficiaryDetail.customerName}
                    </p>
                    <p className="text-[#111827] text-xs">
                      {getCurrencySign(transaction.fromCurrencyCode)}
                      {formatAmount(transaction.sentAmount)} →{' '}
                      {getCurrencySign(transaction.toCurrencyCode)}
                      {formatAmount(transaction.expectedAmount)}
                    </p>
                  </div>
                  <p className="text-[#16A34A] text-xs font-semibold">
                    {transaction.transactionStatus}
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-[#111827] text-sm font-light">
              No recent payout
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
